/**
 * Parse what someone typed into a weight box.
 *
 * Previously `Number(raw)` was used, so "60kg", "60 kg" or "62,5" parsed as NaN
 * and the save was silently skipped — the number stayed on screen but was never
 * stored. This accepts a unit suffix and a decimal comma, and reports anything
 * it can't read so the UI can flag it instead of dropping it.
 */
export type ParsedWeight =
  | { ok: true; value: number | null } // null = box cleared
  | { ok: false }

export function parseWeight(raw: string): ParsedWeight {
  const s = raw.trim().toLowerCase().replace(/\s*(kgs?|kilos?)$/, '').replace(',', '.').trim()
  if (s === '') return { ok: true, value: null }
  if (!/^\d+(\.\d+)?$/.test(s)) return { ok: false }
  const n = Number(s)
  if (!Number.isFinite(n) || n > 1000) return { ok: false }
  return { ok: true, value: n }
}
